import React from "react";
import "./InfoPages.css";

const Contact = () => {
  return (
    <main className="info-page">
      <section className="info-card">
        <h1>Contact SBT-Exam</h1>
        <p>Need help with exam access, login, or scoring questions?</p>
        <p>
          Email: <strong>vinay3829100@gmail.com</strong>
        </p>
        <p>Support Hours: Mon-Sat, 9:00 AM - 6:00 PM (IST)</p>
      </section>
    </main>
  );
};

export default Contact;
